export default "__VITE_ASSET__Co0EaQVE__"